// selectors/dashboardSelectors.js
import { createSelector } from 'reselect';

const selectDashboardData = (state) => state.dashboardData || {};

export const selectShowData = createSelector(
  [selectDashboardData],
  (data) => data.show_data || null
);

// Policies
export const selectPolicyStatusCounts = createSelector(
  [selectDashboardData],
  (data) => data.policies?.lineOfBusinessCounts || []
);

export const selectPolicyDataByPremium = createSelector(
  [selectDashboardData],
  (data) => data.policies?.lineOfBusinessPremium || []
);

// Policy Type
export const selectPolicyTypeCounts = createSelector(
  [selectDashboardData],
  (data) => data.all_policy_type?.policyTypeCounts || []
);

export const selectPolicyTypeByPercentage = createSelector(
  [selectDashboardData],
  (data) => data.all_policy_type?.policyTypePercentages || []
);

export const selectPolicyTypeByPremium = createSelector(
  [selectDashboardData],
  (data) => data.all_policy_type?.policyTypePremiums || []
);

export const selectPolicyTypeTotalCount = createSelector(
  [selectDashboardData],
  (data) => data.all_policy_type?.totalCount || []
);

// Quotes
export const selectQuoteStatusCount = createSelector(
  [selectDashboardData],
  (data) => data.quotes?.statusCounts || []
);

export const selectQuoteStatusCountPercentage = createSelector(
  [selectDashboardData],
  (data) => data.quotes?.statusPercentages || []
);

export const selectQuoteTotalCount = createSelector(
  [selectDashboardData],
  (data) => data.quotes?.totalCount || []
);

// Tasks
export const selectTaskTotalCount = createSelector(
  [selectDashboardData],
  (data) => data.all_task?.totalCount || []
);

export const selectTaskCount = createSelector(
  [selectDashboardData],
  (data) => data.all_task?.statusCounts || []
);

export const selectTaskCountByPercentage = createSelector(
  [selectDashboardData],
  (data) => data.all_task?.statusPercentages || []
);

// Priority Tasks
export const selectPriorityTaskTotalCount = createSelector(
  [selectDashboardData],
  (data) => data.all_priority_task?.totalCount || []
);

export const selectPriorityTaskCount = createSelector(
  [selectDashboardData],
  (data) => data.all_priority_task?.taskTypeCounts || []
);

export const selectPriorityTaskPercentage = createSelector(
  [selectDashboardData],
  (data) => data.all_priority_task?.taskTypePercentages || []
);

// Task Type
export const selectTaskTypeCount = createSelector(
  [selectDashboardData],
  (data) => data.all_task_type?.totalCount || []
);

export const selectOpenTaskCount = createSelector(
  [selectDashboardData],
  (data) => data.all_task_type?.taskTypeCounts || []
);

export const selectOpenTaskPercentage = createSelector(
  [selectDashboardData],
  (data) => data.all_task_type?.taskTypePercentages || []
);

export const selectTaskList = createSelector(
  state => state.dashboardData.all_task?.addTaskList?.content || [],
  tasks => tasks
);

export const selectTaskListPagination = createSelector(
  state => state.dashboardData.all_task?.addTaskList || [],
  tasks => tasks
);

export const selectPoliciesPage = createSelector(
  [selectDashboardData],
  (dashboardData) => dashboardData.policies?.policiesPage || {}
);

export const selectDashboardPolicyDataList = createSelector(
  [selectPoliciesPage],
  (policiesPage) => policiesPage.content || []
);